import { createContext, useContext } from "react";
import type { MainProductDerived, OptionalPartViewModel } from "~/features/addToCart/hooks/useAddToCartForm";
import type { AddToCartSubmitData } from "~/features/addToCart/hooks/useAddToCartForm";

export interface AddToCartDerivedData {
  main: MainProductDerived;
  initialPackCodeResolved: boolean;
  optionalParts: {
    byId: Record<string, OptionalPartViewModel>;
    ids: string[];
  };
  prepareSubmitData: () => AddToCartSubmitData;
}

export const AddToCartDerivedContext = createContext<AddToCartDerivedData | null>(null);
export const AddToCartDerivedContextProvider = AddToCartDerivedContext.Provider;

export const useAddToCartDerived = (): AddToCartDerivedData => {
  const ctx = useContext(AddToCartDerivedContext);
  if (!ctx) {
    throw new Error("useAddToCartDerived must be used within an AddToCartDerivedContext.Provider");
  }
  return ctx;
};
